import "../App.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../config";
import "@fontsource/open-sans";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/400-italic.css";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { toast } from "wc-toast";
import { connect } from "react-redux";
import { SetId, ShowWelcome } from "./redux/actions";
import logo from "../logo1.png";

function Sign_in({ SetId, ShowWelcome }) {
  const navigate = useNavigate();

  const [two_fa, setTwo_fa] = useState(false);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [show, setShow] = useState(true);
  const [totp, setTotp] = useState("");
  const [myid, setMyid] = useState(null);

  const [one, setOne] = useState("");
  const [two, setTwo] = useState("");
  const [three, setThree] = useState("");
  const [four, setFour] = useState("");
  const [five, setFive] = useState("");
  const [six, setSix] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Please wait...");

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const startLoader = (message = "Please wait...") => {
    setLoadingMessage(message);
    setIsLoading(true);
  };

  const stopLoader = () => {
    setIsLoading(false);
    setLoadingMessage("Please wait...");
  };

  const navigateWithLoader = (path, message = "Opening...") => {
    startLoader(message);
    setTimeout(() => {
      navigate(path);
    }, 180);
  };

  async function decide_to_go_welcome(key) {
    try {
      startLoader("Preparing your dashboard...");

      let license = (
        await db.ref("Sign_up").child(String(key)).child("license").once("value")
      ).val();

      let ai = (await db.ref(`ai_settings/${key}`).once("value")).val();

      let devices = (
        await db.ref("userdb").child(String(key)).child("devices").once("value")
      ).val();

      let content = (
        await db.ref("userdb").child(String(key)).child("content").once("value")
      ).val();

      if (license || (ai && devices && content)||(devices)) {
        navigate("/Devices");
      } else {
        ShowWelcome(true);
        navigate("/Welcome");
      }
    } catch (error) {
      console.error("Navigation decision error:", error);
      stopLoader();
      toast.error("Something went wrong. Please try again.");
    }
  }

  useEffect(() => {
    const windowSizeHandler = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", windowSizeHandler);
    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  const isMobile = width <= 768;
  const cardWidth = isMobile ? "92%" : 575;
  const inputHeight = isMobile ? 56 : 62;
  const cardRadius = isMobile ? 18 : 20;

  useEffect(() => {
    ref1.current?.focus();
  }, [two_fa]);

  useEffect(() => {
    if (one.length === 1) ref2.current?.focus();
  }, [one]);

  useEffect(() => {
    if (two.length === 1) ref3.current?.focus();
  }, [two]);

  useEffect(() => {
    if (three.length === 1) ref4.current?.focus();
  }, [three]);

  useEffect(() => {
    if (four.length === 1) ref5.current?.focus();
  }, [four]);

  useEffect(() => {
    if (five.length === 1) ref6.current?.focus();
  }, [five]);

  useEffect(() => {
    if (
      one.length === 1 &&
      two.length === 1 &&
      three.length === 1 &&
      four.length === 1 &&
      five.length === 1 &&
      six.length === 1
    ) {
      const code = one + two + three + four + five + six;
      setTotp(code);
    }
  }, [one, two, three, four, five, six]);

  async function signInWithEmailAndPassword(email, password) {
    try {
      const result = await auth.signInWithEmailAndPassword(email, password);

      if (result) {
        console.log("User signed in successfully");
        return true;
      }

      toast.error("Incorrect email or password. Please try again.");
      return false;
    } catch (error) {
      console.error("Error signing in:", error);

      if (error.code === "auth/user-not-found") {
        toast.error("No user found with this email. Please sign up.");
      } else if (error.code === "auth/wrong-password") {
        toast.error("Incorrect password. Please try again.");
      } else {
        toast.error("Incorrect email or password. Please try again.");
      }

      return false;
    }
  }

  async function verifyCode() {
    try {
      if (!totp || !myid?.id) {
        toast("Please enter the full verification code.");
        return;
      }

      startLoader("Verifying your code...");

      let response = await fetch(
        `https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app/verify?totp=${Number(
          totp
        )}&userId=${myid.id}`
      );

      response = await response.json();

      if (response) {
        setTwo_fa(true);
        toast.success("Successfully Log In");

        const my_id = myid.id;
        SetId(myid);
        localStorage.setItem("display", JSON.stringify(myid));
        decide_to_go_welcome(my_id);
      } else {
        stopLoader();
        toast.error("Invalid TOTP code. Please try again.");
        setTotp("");
        setOne("");
        setTwo("");
        setThree("");
        setFour("");
        setFive("");
        setSix("");
        ref1.current?.focus();
      }
    } catch (error) {
      console.error("Error verifying code:", error);
      stopLoader();
      toast.error("Something went wrong. Please try again.");
    }
  }

  async function Sign_in_Function() {
    if (email !== "" && pass !== "") {
      startLoader("Signing you in...");

      const room = db.ref("Sign_up");

      const res = await signInWithEmailAndPassword(email.toLowerCase(), pass);

      if (res !== true) {
        stopLoader();
        return;
      }

      try {
        await auth.signInWithEmailAndPassword(
          "n.joy@boomsoftware.co.uk",
          "2103199j"
        );

        const snap = await room
          .orderByChild("Email")
          .equalTo(email.toLowerCase())
          .once("value");

        if (snap.val() == null) {
          stopLoader();
          toast.error("No user found with this email. Please sign up.");
        } else {
          const object = snap.val();
          const arr = Object.values(object);

          if (
            arr[0].secret !== undefined &&
            arr[0].secret !== null &&
            arr[0].secret !== ""
          ) {
            stopLoader();
            setTwo_fa(true);
            setMyid(arr[0]);
          } else {
            toast.success("Successfully Log In");
            const my_id = arr[0].id;

            SetId(arr[0]);
            localStorage.setItem("display", JSON.stringify(arr[0]));
            decide_to_go_welcome(my_id);
          }
        }
      } catch (error) {
        console.error("Sign in flow error:", error);
        stopLoader();
        toast.error("Something went wrong. Please try again.");
      }
    } else {
      toast.error("Empty field are not accepted");
    }
  }

      return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "#02080D",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "24px 16px" : "40px 20px",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <wc-toast></wc-toast>

      {/* ================= PREMIUM LOADER MODAL ================= */}
      {isLoading ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(2, 8, 13, 0.72)",
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: isMobile ? "92%" : 430,
              maxWidth: "100%",
              borderRadius: 22,
              background:
                "linear-gradient(180deg, rgba(26,35,48,0.98) 0%, rgba(18,27,39,0.98) 100%)",
              border: "1px solid rgba(247,148,29,0.24)",
              boxShadow:
                "0 24px 70px rgba(0,0,0,0.42), 0 0 0 1px rgba(255,255,255,0.03) inset",
              padding: isMobile ? "28px 22px" : "32px 28px",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: 180,
                height: 180,
                borderRadius: "50%",
                background: "rgba(247,148,29,0.10)",
                filter: "blur(40px)",
                top: -40,
                right: -30,
              }}
            />

            <div
              style={{
                position: "relative",
                width: 84,
                height: 84,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 22,
              }}
            >
              <div
                style={{
                  position: "absolute",
                  width: 84,
                  height: 84,
                  borderRadius: "50%",
                  border: "3px solid rgba(247,148,29,0.12)",
                  borderTop: "3px solid #F7941D",
                  animation: "boomSpin 1s linear infinite",
                  boxSizing: "border-box",
                }}
              />
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: "50%",
                  background:
                    "radial-gradient(circle at 30% 30%, #F7B04A 0%, #F7941D 55%, #D87A0C 100%)",
                  boxShadow: "0 0 28px rgba(247,148,29,0.35)",
                }}
              />
            </div>

            <div
              style={{
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontWeight: 700,
                fontSize: isMobile ? 24 : 26,
                lineHeight: isMobile ? "32px" : "34px",
              }}
            >
              Boom Display
            </div>

            <div
              style={{
                marginTop: 10,
                color: "rgba(255,255,255,0.82)",
                fontFamily: "Open Sans",
                fontWeight: 400,
                fontSize: isMobile ? 16 : 17,
                lineHeight: isMobile ? "26px" : "28px",
              }}
            >
              {loadingMessage}
            </div>

            <div
              style={{
                marginTop: 18,
                width: "100%",
                maxWidth: 220,
                height: 6,
                borderRadius: 999,
                background: "rgba(255,255,255,0.08)",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: "42%",
                  height: "100%",
                  borderRadius: 999,
                  background:
                    "linear-gradient(90deg, #F7941D 0%, #FFB347 100%)",
                  animation: "boomLoaderBar 1.15s ease-in-out infinite",
                  transformOrigin: "left center",
                }}
              />
            </div>
          </div>

          <style>
            {`
              @keyframes boomSpin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }

              @keyframes boomLoaderBar {
                0% { transform: translateX(-110%); }
                100% { transform: translateX(260%); }
              }
            `}
          </style>
        </div>
      ) : null}

      {/* ================= LOGIN CARD ================= */}
      <div
        style={{
          width: cardWidth,
          maxWidth: "100%",
          background: "#1A2330",
          borderRadius: cardRadius,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: isMobile ? "34px 22px 30px" : "42px 52px 36px",
          boxSizing: "border-box",
          boxShadow: "0 18px 50px rgba(0,0,0,0.28)",
        }}
      >
        {/* ================= LOGO ================= */}
        <img
          src={logo}
          alt="Boom Display"
          style={{
            width: isMobile ? 132 : 150,
            height: "auto",
            objectFit: "contain",
            display: "block",
            marginBottom: isMobile ? 30 : 38,
          }}
        />

        {/* ================= EMAIL INPUT ================= */}
        <input
          placeholder="Email"
          style={{
            width: "100%",
            height: inputHeight,
            borderRadius: 10,
            backgroundColor: "#DDF1F2",
            outline: "none",
            border: "1px solid #2CC7C7",
            color: "#6E6680",
            fontSize: isMobile ? 18 : 19,
            fontWeight: 400,
            paddingLeft: 18,
            paddingRight: 18,
            fontFamily: "Open Sans",
            boxSizing: "border-box",
          }}
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* ================= PASSWORD OR OTP ================= */}
        {!two_fa ? (
          <div
            style={{
              width: "100%",
              height: inputHeight,
              marginTop: 18,
              borderRadius: 10,
              backgroundColor: "#DDF1F2",
              border: "1px solid #2CC7C7",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxSizing: "border-box",
              paddingLeft: 18,
              paddingRight: 16,
            }}
          >
            <input
              placeholder="Password"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                outline: "none",
                backgroundColor: "transparent",
                color: "#6E6680",
                fontSize: isMobile ? 18 : 19,
                fontWeight: 400,
                fontFamily: "Open Sans",
              }}
              type={show ? "password" : "text"}
              value={pass}
              onChange={(e) => setPass(e.target.value)}
            />

            <div
              onClick={() => setShow(!show)}
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: 10,
                flexShrink: 0,
              }}
            >
              {show ? (
                <FaRegEyeSlash size={20} color="#7C7A86" />
              ) : (
                <FaRegEye size={20} color="#7C7A86" />
              )}
            </div>
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              marginTop: 18,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: isMobile ? 6 : 10,
            }}
          >
            <input
              ref={ref1}
              placeholder="X"
              style={{
                width: isMobile ? 44 : 60,
                height: isMobile ? 50 : 56,
                borderRadius: 8,
                backgroundColor: "#DDF1F2",
                outline: "none",
                border: "1px solid #2CC7C7",
                color: "#000000",
                fontSize: isMobile ? 20 : 22,
                textAlign: "center",
                fontFamily: "Open Sans",
                boxSizing: "border-box",
              }}
              type="text"
              value={one}
              onChange={(e) => setOne(e.target.value.slice(-1))}
            />

            <input
              ref={ref2}
              placeholder="X"
              style={{
                width: isMobile ? 44 : 60,
                height: isMobile ? 50 : 56,
                borderRadius: 8,
                backgroundColor: "#DDF1F2",
                outline: "none",
                border: "1px solid #2CC7C7",
                color: "#000000",
                fontSize: isMobile ? 20 : 22,
                textAlign: "center",
                fontFamily: "Open Sans",
                boxSizing: "border-box",
              }}
              type="text"
              value={two}
              onChange={(e) => setTwo(e.target.value.slice(-1))}
            />

            <input
              ref={ref3}
              placeholder="X"
              style={{
                width: isMobile ? 44 : 60,
                height: isMobile ? 50 : 56,
                borderRadius: 8,
                backgroundColor: "#DDF1F2",
                outline: "none",
                border: "1px solid #2CC7C7",
                color: "#000000",
                fontSize: isMobile ? 20 : 22,
                textAlign: "center",
                fontFamily: "Open Sans",
                boxSizing: "border-box",
              }}
              type="text"
              value={three}
              onChange={(e) => setThree(e.target.value.slice(-1))}
            />

            <input
              ref={ref4}
              placeholder="X"
              style={{
                width: isMobile ? 44 : 60,
                height: isMobile ? 50 : 56,
                borderRadius: 8,
                backgroundColor: "#DDF1F2",
                outline: "none",
                border: "1px solid #2CC7C7",
                color: "#000000",
                fontSize: isMobile ? 20 : 22,
                textAlign: "center",
                fontFamily: "Open Sans",
                boxSizing: "border-box",
              }}
              type="text"
              value={four}
              onChange={(e) => setFour(e.target.value.slice(-1))}
            />

            <input
              ref={ref5}
              placeholder="X"
              style={{
                width: isMobile ? 44 : 60,
                height: isMobile ? 50 : 56,
                borderRadius: 8,
                backgroundColor: "#DDF1F2",
                outline: "none",
                border: "1px solid #2CC7C7",
                color: "#000000",
                fontSize: isMobile ? 20 : 22,
                textAlign: "center",
                fontFamily: "Open Sans",
                boxSizing: "border-box",
              }}
              type="text"
              value={five}
              onChange={(e) => setFive(e.target.value.slice(-1))}
            />

            <input
              ref={ref6}
              placeholder="X"
              style={{
                width: isMobile ? 44 : 60,
                height: isMobile ? 50 : 56,
                borderRadius: 8,
                backgroundColor: "#DDF1F2",
                outline: "none",
                border: "1px solid #2CC7C7",
                color: "#000000",
                fontSize: isMobile ? 20 : 22,
                textAlign: "center",
                fontFamily: "Open Sans",
                boxSizing: "border-box",
              }}
              type="text"
              value={six}
              onChange={(e) => setSix(e.target.value.slice(-1))}
            />
          </div>
        )}

        {/* ================= FORGOT PASSWORD ================= */}
        {!two_fa ? (
          <div
            onClick={() => navigateWithLoader("/Forget", "Opening forgot password...")}
            style={{
              width: "100%",
              marginTop: 14,
              textAlign: "left",
              cursor: "pointer",
              fontFamily: "Open Sans",
              fontWeight: 400,
              fontSize: isMobile ? 17 : 18,
              color: "#F2F2F2",
            }}
          >
            Forgot Password?
          </div>
        ) : null}

        {/* ================= PRIMARY BUTTON ================= */}
        {!two_fa ? (
          <button
            onClick={() => Sign_in_Function()}
            style={{
              width: "100%",
              height: isMobile ? 58 : 62,
              marginTop: 28,
              border: "none",
              borderRadius: 10,
              backgroundColor: "#F7941D",
              color: "#000000",
              fontFamily: "Open Sans",
              fontWeight: 700,
              fontSize: isMobile ? 20 : 22,
              cursor: "pointer",
              boxSizing: "border-box",
            }}
          >
            Log In
          </button>
        ) : (
          <button
            onClick={() => verifyCode()}
            style={{
              width: "100%",
              height: isMobile ? 58 : 62,
              marginTop: 26,
              border: "none",
              borderRadius: 10,
              backgroundColor: "#F7941D",
              color: "#000000",
              fontFamily: "Open Sans",
              fontWeight: 700,
              fontSize: isMobile ? 20 : 22,
              cursor: "pointer",
              boxSizing: "border-box",
            }}
          >
            Confirm
          </button>
        )}

        {/* ================= CREATE ACCOUNT ================= */}
        {!two_fa ? (
          <div
            style={{
              width: "100%",
              marginTop: 26,
              textAlign: "center",
              fontFamily: "Open Sans",
              fontWeight: 400,
              fontSize: isMobile ? 17 : 18,
              color: "#F2F2F2",
              lineHeight: "28px",
            }}
          >
            Don&apos;t have any Account?{" "}
            <span
              onClick={() =>
                navigateWithLoader("/Free_trials", "Opening registration...")
              }
              style={{
                color: "#F7941D",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Register
            </span>
          </div>
        ) : null}
      </div>

      {/* ================= TOP RIGHT CTA ================= */}
      {!two_fa ? (
        <button
          onClick={() =>
            navigateWithLoader("/Free_trials", "Opening free trial...")
          }
          style={{
            position: "absolute",
            top: isMobile ? 16 : 24,
            right: isMobile ? "auto" : 24,
            left: isMobile ? "50%" : "auto",
            transform: isMobile ? "translateX(-50%)" : "none",
            height: isMobile ? 46 : 52,
            padding: isMobile ? "0 18px" : "0 24px",
            borderRadius: 10,
            border: "2px solid #F7941D",
            background: "#F7941D",
            color: "#000000",
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: isMobile ? 14 : 16,
            cursor: "pointer",
            boxSizing: "border-box",
            zIndex: 5,
            whiteSpace: "nowrap",
            transition: "all 0.18s ease",
          }}
          onMouseEnter={(e) => {
            if (!isMobile) e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            if (!isMobile) e.currentTarget.style.transform = "translateY(0px)";
          }}
        >
          Start your free trial today
        </button>
      ) : null}

      {/* ================= VERSION ================= */}
      <div
        style={{
          position: "absolute",
          bottom: 14,
          left: isMobile ? 16 : 20,
          fontSize: 14,
          color: "rgba(255,255,255,0.72)",
          fontWeight: 600,
          letterSpacing: 1,
          fontFamily: "Open Sans",
        }}
      >
        Version 1.7
      </div>
    </div>
  );
}

export default connect(null, { SetId , ShowWelcome})(Sign_in);